import * as React from "react";
import { forwardRef } from "react";
const SvgAuto = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0005 1.49319C10.0005 1.04773 9.46188 0.824648 9.1469 1.13965L2.14841 8.13879C1.83345 8.45378 2.05654 8.99232 2.50198 8.99232H5.99953V14.499C5.99953 14.9445 6.53812 15.1675 6.8531 14.8525L13.8516 7.8534C14.1666 7.53841 13.9435 6.99986 13.498 6.99986H10.0005V1.49319Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgAuto);
export default ForwardRef;
